exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.selector[data-v-01e1fdc6] {\n    max-width: 200px;\n}\n", ""]);

// exports
